import React from 'react';
import { useTranslation } from "react-i18next";
import './ModalFieldInfo.scss';
import Modal from "../Modal/Modal";

const ModalFieldInfo = (props) => {
    const { t } = useTranslation();

    const descriptionRender = () =>{
        return(
            <div className="pass-desc">
                <p className="desc-title">{t('password.info.title')}</p>
                    <div className="inner-desc">
                        <ul>
                          <li><p className="p-point">{t('password.info.point1')}</p></li>
                          <li><p className="p-point">{t('password.info.point2')}</p></li>
                          <li className="p-point-inner"><p className="p-point">{t('password.info.point3')}</p></li>
                          <li className="p-point-inner"><p className="p-point">{t('password.info.point4')}</p></li>
                          <li className="p-point-inner"><p className="p-point">{t('password.info.point5')}</p></li>
                          <li className="p-point-inner"><p className="p-point">{t('password.info.point6')}</p></li>
                          <li><p className="p-point">{t('password.info.point7')}</p></li>
                          <li><p className="p-point">{t('password.info.point8')}</p></li>
                          <li><p className="p-point">{t('password.info.point9')}</p></li>
                        </ul>
                    </div>
            </div>
        )
    }

    return (
      <div className="ModalFieldInfo" data-testid={"ModalFieldInfo"}>
        <Modal
          show={true}
          onClose={
            props.componentChangePass?
             props.editPass
            :
            () => {
              if (props.password) {
                  props.setFieldPass(false);
              }
              if (props.contactEmail) {
                  props.setIsContactEmail(false);
              }
              if (props.contactEmailInfo) {
                  props.setIsContactEmailInfo(false);
              }
              props.setFieldInfo(false)
            }
          }
          content = { props.password ?
            descriptionRender() :
            props.contactEmail ? (
             <p>{t("registration.popup.info.admincontactemail")}</p>
            ) : (
              props.contactEmailInfo ? (
                <p>{t("registration.popup.info.contactemail")}</p>
              ) : (
                props.isLegacy ? (
                  <p>{t("registration.popup.info.legacy")}</p>
                ) : (
                  props.condAdminEmailReg ? (
                    <p>{t("registration.popup.info.username")}</p>
                  ) : (
                    <p>{t("registration.popup.info.nolegacy")}</p>
                  )
                )
              )
            )
          }
          type={"button"}
          styleType={"primary"}
          onFirstClick={
             props.componentChangePass?
              props.editPass
             :
             () => {
               if (props.password) {
                props.setFieldPass(false);
               }
               if (props.contactEmail) {
                   props.setIsContactEmail(false);
               }
               if (props.contactEmailInfo) {
                   props.setIsContactEmailInfo(false);
               }
               if (props.condAdminEmailReg) {
                   props.setIsCondAdminEmailReg(false);
               }
               props.setFieldInfo(false);
             }
          }
          linkTitle={t("registration.popup.info.legacy.button")}
        />
      </div>
    );
  };


  export default ModalFieldInfo;
